// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import { ButtonPrimary } from "components/layout/Button/ButtonPrimary";

export const StyledAcceptVideoChatButton = styled(ButtonPrimary)`
	margin: 0.5rem 0 0.25rem 0;
	white-space: nowrap;
`;
